import React from 'react'
import SkipQuestion from '../../assets/images/skip-question-img.svg'
import Modal from "react-bootstrap/Modal";
import { useSelector, useDispatch } from 'react-redux';
import { setSkipModalData } from '../../redux/onboardingReducer';
import { useLocation, useNavigate } from 'react-router-dom';
function QuestionSkipModal() {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const path = useLocation();
    const { skipModal } = useSelector((state) => state.onboardingDetails.data);
    const handleSkipQuestion = () => {
        let num = path.pathname[path.pathname.length - 1];
        dispatch(setSkipModalData(false))
        if (num === "0") {
            navigate("/dashboard");
          } else {
            navigate(`/q${parseInt(num) + 1}`);
          }
    }
    return (
        < Modal
            show={skipModal}
            onHide={() => dispatch(setSkipModalData(false))
            }
            centered
        >
            <Modal.Body>
                <h5 className="skip-question-head mt-3">
                    If you skip this question, we may not have enough information to be
                    fully prepared for the meeting.
                </h5>
                <div className="skip-question-img">
                    <img src={SkipQuestion} alt="Skip" />
                </div>
                <p>
                    Would you like to confirm that you still want to skip this question?
                </p>
                <div className="d-flex justify-content-between mt-5">
                    <button
                        type="button"
                        className="as-btn-secondary w-100 mr-2"
                        onClick={handleSkipQuestion}
                    >
                        Skip Question
                    </button>
                    <button
                        type="button"
                        className="as-btn-primary w-100 ml-2"
                        onClick={() => dispatch(setSkipModalData(false))}
                    >
                        Cancel
                    </button>
                </div>
            </Modal.Body>
        </Modal >
    )
}

export default QuestionSkipModal
